import AIRecommendedSolutions from './AIRecommendedSolutions';

export default AIRecommendedSolutions;
